/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 发现店铺
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class ShopsDiscoverParams {
  constructor(public page: number, public size: number) {}
}

export default async function (
  params: ShopsDiscoverParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: good.Page<good.TheaterShopSearchDto>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/good/shops/discover`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
